import {fetchAssociateMetricsV2} from "../network/AssociateNetworkAPIV2";

export const AssociatePerformanceReducerV2 = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {dispatcher, baseUrl, stationConfig} = action.data;
            fetchAssociateMetricsV2(dispatcher, baseUrl, stationConfig);
            return state;
        case "RECEIVE_DATA":
            return {...state, ...action.data};
        case "SORT_DATA":
            return {...state, sortPref: action.data};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/outboundassociate/reducers/AssociatePerformanceReducerV2.js